export default __webpack_public_path__ + "static/media/FredokaOne-Regular.3888a8fd.ttf";